import { create } from "zustand";

type TriggerPaymentAction =
  | undefined
  | "explorer"
  | "radar"
  | "creditPack"
  | "pro";
type TriggerUpdatePriceAction =
  | undefined
  | "add_restaurants"
  | "delete_restaurant";

type UpdateActionPrice = {
  action: TriggerUpdatePriceAction;
  restaurantsId: string[];
  quantity: number;
};

type PaymentActionState = {
  triggerPaymentAction: TriggerPaymentAction;
  triggerUpdatePriceAction: TriggerUpdatePriceAction;
  priceId?: string;
  restaurantsId: string[];
  quantity: number;
};

export const paymentActionState = create<PaymentActionState>(() => ({
  triggerPaymentAction: undefined,
  triggerUpdatePriceAction: undefined,
  priceId: undefined,
  restaurantsId: [],
  quantity: 1,
}));

export const setPaymentAction = (action: TriggerPaymentAction) =>
  paymentActionState.setState(() => ({ triggerPaymentAction: action }));

export const setUpdatePriceAction = (payload: UpdateActionPrice) =>
  paymentActionState.setState(() => ({
    triggerUpdatePriceAction: payload.action,
    restaurantsId: payload.restaurantsId,
    quantity: payload.quantity,
  }));

export const setRestaurantsIdsToUpdatePrice = (restaurantsId: string[]) =>
  paymentActionState.setState(() => ({ restaurantsId: restaurantsId }));

export const setPriceId = (priceId: string | undefined) =>
  paymentActionState.setState(() => ({ priceId }));
